import React from 'react';

export const SearchResultsCounter = ({
    count,
    badgeLabel = 'Resultados'
}) => {
    const isEmpty = count === 0;

    return (
        <div className="mb-3 flex w-full justify-center px-4 lg:px-0">
            <div className={[
                'inline-flex max-w-full flex-wrap items-center justify-center gap-2 rounded-full border px-3 py-2 shadow-sm',
                isEmpty
                    ? 'border-amber-200 bg-amber-50/80'
                    : 'border-blue-gray-100 bg-white'
            ].join(' ')}>
                <span className="text-[11px] font-semibold uppercase tracking-wide text-blue-gray-500">
                    {badgeLabel}
                </span>

                <span className={[
                    'rounded-full px-2.5 py-1 text-sm font-bold leading-none tabular-nums',
                    isEmpty
                        ? 'bg-amber-100 text-amber-800'
                        : 'bg-cyan-500 text-white'
                ].join(' ')}>
                    {count.toLocaleString()}
                </span>
            </div>
        </div>
    );
};